
<template>
    <div class="container-fluid">
        <div class="row justify-content-center flex-nowrap">
            <div class="col-1"></div>
            <div class="col">
                <div class="container">
                    <div class="row">
                        <div class="col align-self-start">
                            <information-visualisation id=0 name="Ihr Auswertungergebnis"></information-visualisation>
                        </div>
                        <div class="col-sm-4 align-self-start">
                            <score :value="fetchMaturityLevel()" phase="" > </score>
                            <div class="card" style="">
                                <div class="card-body">
                                    <p class="m-1">
                                        Die Auswertung ist in folgende Phasen strukturiert:
                                    </p>
                                    <!--<vertical-nav :phases = this.$parent.phases :useIcon="true"></vertical-nav>-->
                                    <vertical-nav :phases = phases :useIcon="true"></vertical-nav>
                                    <p class="m-1">
                                        Jede Phase kann individuell betrachtet werden. Zu einigen Phasen wurden Rahmenbedingungen erhoben, die separat einsehbar sind.
                                    </p>
                                </div>
                            </div>
                            <!--<button class="btn btn-primary w-100" style="" @click="showAlert">
                                <svg xmlns="http://www.w3.org/2000/svg" width="25" height="25" fill="white" class="bi bi-download" viewBox="0 0 16 16">
                                    <path d="M.5 9.9a.5.5 0 0 1 .5.5v2.5a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1v-2.5a.5.5 0 0 1 1 0v2.5a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2v-2.5a.5.5 0 0 1 .5-.5z"/>
                                    <path d="M7.646 11.854a.5.5 0 0 0 .708 0l3-3a.5.5 0 0 0-.708-.708L8.5 10.293V1.5a.5.5 0 0 0-1 0v8.793L5.354 8.146a.5.5 0 1 0-.708.708l3 3z"/>
                                </svg>
                                Reifegradmodell als PDF speichern
                            </button>-->
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-1 align-self-center">
                <arrow direction="right"
		    v-if="phases && phases.length > 0" 
                    :route="'/result/phase/' + phases[0].Name.replaceAll('-', '').replace(/\s/g, '-').toLowerCase()" 
                    :routeName="phases[0].Name">
                </arrow>
            </div>
        </div>
    </div>
</template>

<script>
import Score from "../js/components/Score.vue";
import InformationVisualisation from '../js/components/InformationVisualisation.vue';
import VerticalNav from '../js/components/VerticalNav.vue';
import Arrow from '../js/components/Arrow.vue';



export default {
    name: "Overview",
    components: {
        Score,
        InformationVisualisation,
        VerticalNav,
        Arrow
    },

    data: function() {
        return {
            maturityLevel: null,
        };
    },
    props: {
        phases: []
    },
    created() {
    },

    methods: {
        showAlert(){
            alert("PDF erfolgreich runtergeladen!");
        },

        fetchMaturityLevel() {
            let vm = this;
            axios
                .get("/api/maturityLevel")
                .then(response => {
                    //this.maturityLevel = response.data[0].AvgMaturityLevelValue;
                    var doubleMaturityLevel = response.data[0].AvgMaturityLevelValue;                    
                    var stringMaturityLevel = doubleMaturityLevel + '';                    
                    if(stringMaturityLevel[0] == '.')
                    {
                        stringMaturityLevel = '0' + stringMaturityLevel;
                    }
                    this.maturityLevel = stringMaturityLevel;           
                })
                .catch(err => console.log(err)); 
            
            return this.maturityLevel;
        }
    }
};
</script>
